import {registerUser, deleteUser} from "./api";

export function loginFacebook(me) {

    if(FB) {
        FB.login(function(response) {
            if (response.status === 'connected') {
                console.log(response)

                FB.api('/me', function(dat) {
                    console.log(dat);

                    let user = {
                        type: "facebook",
                        id: dat.id,
                        nonce_register: me.data('nonce-register'),
                        nonce_login: me.data('nonce-login'),
                        token: response.authResponse.accessToken,
                        remember_me: true
                    }

                    if(me.hasClass("delete-user")) {
                        deleteUser(me,user)
                    } else {
                        registerUser("facebook",user)
                    }

                });

                // Logged into your webpage and Facebook.
            } else {
                console.log(response)
                // The person is not logged into your webpage or we are unable to tell.
            }

        }, {scope: 'public_profile,email'});
    } else {
        console.log("missing FB");
    }

}

export function loginGoogle(data) {

    if(data) {

        let user = {
            nonce_register: $(".soc-logins a.facebook").data("nonce-register"),
            test: $(".soc-logins a.facebook").data("nonce-register"),
            type: "google",
            id: data.sub,
            nonce_login: $(".soc-logins a.facebook").data("nonce-login"),
            remember_me: true,
            first_name: data.given_name,
            last_name: data.family_name,
            email: data.email
        }
        console.log('login user')
         console.log(user)

        let me = $(".soc-logins a.google");

        if(me.hasClass("delete-user")) {
            deleteUser(me,user)
        } else {

            registerUser("google",user)
        }

    } else {
        console.log("missing data");
    }

}